import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import enTranslation from 'assets/locales/en/translation.json';

i18n
  .use(Backend)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en'],
    debug: false,
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: (enTranslation as unknown as string).replace('/en/', '{{lng}}'),
    },
  });
export default i18n;
